export const env = window.location.host ==='localhost:3011' ? 'dev' : window.location.host ==='sand.faith-journals.com' ? 'stage' : 'prod'